export const OPTIONS_FINALITY = [
  {
    value: 'Normal',
    label: 'Normal',
  },
  {
    value: 'Remessa',
    label: 'Remessa',
  },
  {
    value: 'Devolução',
    label: 'Devolução',
  },
  {
    value: 'Retorno',
    label: 'Retorno',
  },
  {
    value: 'Complementar',
    label: 'Complementar',
  },
  {
    value: 'Locação',
    label: 'Locação',
  },
  {
    value: 'Todos',
    label: 'Todos',
  },
];
